import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { type ButtonSize, type ButtonTone, buttonClasses, buttonLabelClasses } from "./Button";

/**
 * Un lien qui a l'allure d'un bouton.
 *
 * Il existe pour une raison précise : un `<Link>` DANS un `<button>` est un
 * élément interactif imbriqué dans un autre. Le navigateur en fait ce qu'il veut,
 * le lecteur d'écran annonce les deux, et le clic ne navigue pas toujours. Quand la
 * destination est une URL, c'est un lien — et il prend juste l'apparence voulue.
 *
 * L'apparence est EXACTEMENT celle de `Button`, par `buttonClasses` : il tenait sa
 * propre copie des rangs, et elle avait déjà dérivé (autre fond, autre survol).
 * `sm` par défaut, pour garder ses 32 px dans les en-têtes de carte.
 */
export function LinkButton({
	to,
	tone = "secondary",
	size = "sm",
	className = "",
	children,
}: {
	to: string;
	tone?: Exclude<ButtonTone, "tertiary">;
	size?: ButtonSize;
	className?: string;
	children: ReactNode;
}) {
	return (
		<Link to={to} className={buttonClasses({ tone, size, className: `shrink-0 ${className}` })}>
			<span className={buttonLabelClasses(size)}>{children}</span>
		</Link>
	);
}
